// extracted by mini-css-extract-plugin
export default {"actions":"CommonActions_actions__yBS5X"};